export default __webpack_public_path__ + "static/media/shop_crates_background.77f6c5dd.png";